import gql from 'graphql-tag';

const KEY_STUDENT_ENGAGEMENT_QUERY = gql`
  query getStudentEngagementReport(
    $where: KeyStudentEngagementReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyStudentEngagementReport(where: $where, dateRange: $dateRange) {
      spotChecks {
        template
        dateCompleted
        wpm
        accuracy
      }
      assessments {
        dateCompleted
        aborted
        averageWpm
        averageAccuracy
        activities {
          template
          aborted
          wpm
          accuracy
        }
      }
      enrichmentActivities {
        template
        dateCompleted
        aborted
        retryCount
        wpm
        accuracy
      }
      assessmentAccelerator {
        averageAttemptCount
        totalFirstAttemptCount
        totalSecondsSpent
        activityTypes {
          activityType {
            id
            name
          }
          modules {
            modules {
              name
              id
            }
            averageAttemptCount
            averageSecondsSpent
            averageAttemptCount
          }
        }
        modules {
          totalFirstAttemptCount
          totalSecondsSpent
          averageAttemptCount
          averageSecondsSpent
          dateCompleted
          modules {
            name
            id
          }
          attempts {
            dateCompleted
            activities {
              activity {
                id
                name
                title
                description
              }
              attemptCount
              responseData
              secondsSpent
            }
          }
        }
      }
      student {
        firstName
        lastName
        gradeLevel
        classrooms {
          name
        }
      }
    }
  }
`;

export default KEY_STUDENT_ENGAGEMENT_QUERY;
